<template>
    <DsComboboxEmpty class="p-4">
        <DsSelectEmptyState
            icon="fa-solid fa-magnifying-glass"
            :subtitle="message"
            :title
        >
            <DsButton
                size="sm"
                variant="tertiary"
                @click.stop="$emit('buttonClick')"
            >
                {{ buttonLabel }}
            </DsButton>
        </DsSelectEmptyState>
    </DsComboboxEmpty>
</template>

<script setup lang="ts">
import type { DsSelectEmptyStateProps } from '@ds/DsSelectEmptyState.vue';
import DsSelectEmptyState from '@ds/DsSelectEmptyState.vue';
import DsButton from '@ds/button/DsButton.vue';
import DsComboboxEmpty from '@ds/form/combobox/DsComboboxEmpty.vue';

defineProps<{
    title: DsSelectEmptyStateProps['title'];
    message: DsSelectEmptyStateProps['subtitle'];
    buttonLabel: string;
}>();

defineEmits<{
    buttonClick: [];
}>();
</script>
